import { RestError } from "../../services/rest-service/RestService";
import { useMutation, useQueryClient } from "react-query";
import { BaseUseMutationParameters } from "../BaseUseMutationParameters";
import { keys } from "./Keys";
import AdminReportDataService from "../../services/admin-report-data-service/AdminReportDataService";
import { IRecipientNotification } from "../../services/admin-report-data-service/Models";

export type MutationContextType = {
    previous: IRecipientNotification[] | undefined;
};

export type UseSaveRecipientsToNotifyParameters = {
    groupID: number
} & BaseUseMutationParameters<void, IRecipientNotification[]>;

export function UseSaveRecipientsToNotify({
    groupID,
    onError,
    onSuccess
}: UseSaveRecipientsToNotifyParameters) {
    const queryClient = useQueryClient();

    return useMutation<void, RestError, IRecipientNotification[], MutationContextType>(
        (data) => {
            return AdminReportDataService.saveRecipientsToNotifyForUser(
                groupID,
                data
            );
        },
        {
            onMutate: async (item: IRecipientNotification[]) => {

                await queryClient.cancelQueries(keys.availableRecipientsToNotifyForUser(groupID));

                const previous = queryClient.getQueryData<IRecipientNotification[]>(keys.availableRecipientsToNotifyForUser(groupID));

                queryClient.setQueryData<IRecipientNotification[]>(
                    keys.availableRecipientsToNotifyForUser(groupID),
                    (_old?: IRecipientNotification[]) => {
                        return item;
                    }
                );


                return {
                    previous 
                };
            },
            onError: onError,
            onSuccess: onSuccess,
            onSettled: (_data, error, _configuration, context) => {

                if (error && context?.previous) {
                    queryClient.setQueryData<IRecipientNotification[]>(
                        keys.availableRecipientsToNotifyForUser(
                            groupID,
                        ),
                        context?.previous
                    );
                }

                queryClient.invalidateQueries(keys.availableRecipientsToNotifyForUser(groupID));
            }
        }
    );
}
